import $ from "jquery";

// 利用規約のチェックに応じて送信ボタンの有効・無効を切り替える。
//
// 以前は「初期状態の反映」→「.policy-checkbox への click ハンドラの直接バインド」の順で書いていたため、
// スクリプトが実行されるより先にチェックボックスが操作されると、そのイベントを取りこぼして
// 送信ボタンが無効のままになることがあった (回線が遅い場合など)。
// document への委譲 + change の監視にすることで、操作とスクリプト読み込みの順序に依存しないようにしている。
//
// また、1ページにサインアップフォームが複数ある場合 (モーダルとページ本体が同居するなど) に
// 互いのボタンを巻き込まないよう、チェックボックスと送信ボタンは同じ form の中だけで対応付ける。
function syncSubmitState(form) {
  const checkbox = form.find(".policy-checkbox");
  if (checkbox.length === 0) return;

  form.find(".submit").prop("disabled", !checkbox.is(":checked"));
}

function syncAllSubmitStates() {
  $(".policy-checkbox").each((_index, checkbox) => {
    syncSubmitState($(checkbox).closest("form"));
  });
}

// 初期状態の反映は turbolinks:load で行う。
// この pack は <head> で defer なしに読み込まれる (layouts/application, layouts/page) ため、
// モジュールの評価時点ではフォームがまだ DOM に無く、ここで直接 syncAllSubmitStates() を呼んでも
// 何も起きない (チェック前から送信ボタンが有効なまま表示されていた)。
// turbolinks:load は初回表示でも Turbolinks の遷移 (戻る・進むの復元を含む) でも発火するので、
// どの経路で表示されても同じ初期状態になる。
$(document).on("turbolinks:load", syncAllSubmitStates);

$(document).on("change", ".policy-checkbox", (event) => {
  syncSubmitState($(event.target).closest("form"));
});
